<template>
    <div class="page-loader">
        <div class="overlay">
            <div>
                <span class="spinner-border"></span>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
body {
    overflow: hidden;
    .page-loader {
        .overlay {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: rgba(255, 255, 255, .7);
            z-index: 9998;

            &>div {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;

                span {
                    border-color: #0000#1170c1#1170c1;
                }
            }
        }
    }
}
</style>